import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthLayout, Layout } from "./common";
import React, { useEffect, useState } from "react";
import { AppContext } from "./context";
import { fetchOrganizationData } from "./common/service";
import { setPageMeta } from "./utils";
import { getCurrentUser } from "./auth/service";
import { initGA } from "./common/analytics";
const AUTH_ROUTES = [
  "/login",
  "/login_with_otp",
  "/register",
  "/cl",
  "/admin_login",
];

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [catalogs, setCatalogs] = useState({});
  const [projectInfo, setProjectInfo] = useState({});
  const [clearSearch, setClearSearch] = useState(false);
  const [isSubModule, setIsSubModule] = useState(false);
  const [isRemarksOn, setIsRemarksOn] = useState(false);
  const [isExpoOn, setIsExpoOn] = useState(false);
  const [bomSummary, setBomSummary] = useState({ loaded: false });
  const [catalogsLoading, setCatalogsLoading] = useState(false);
  const [organizationData, setOrganizationData] = useState({});
  const [forceRefreshSpaceConfigStatus, setForceRefreshSpaceConfigStatus] =
    useState(false);
  const [orderContext, setOrderContext] = useState([]);
  const [currentUser, setCurrentUser] = useState([]);
  const [isSessionLoaded, setIsSessionLoaded] = useState(false);
  // Cart (Store) — so View Cart in header opens pane without navigating
  const [cart, setCart] = useState([]);
  const [cartUuid, setCartUuid] = useState(() => localStorage.getItem("store_cart_uuid") || null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  const toggleCart = () => setIsCartOpen((v) => !v);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const openAuthModal = () => setIsAuthModalOpen(true);
  const closeAuthModal = () => setIsAuthModalOpen(false);

  useEffect(() => {
    // Initialize GA for app pages
    initGA();
    setPageMeta();

    if (location.pathname === "/") {
      const currentUser = getCurrentUser();

      currentUser && !currentUser.isFromLandingPage
        ? navigate("/projects")
        : navigate("/home");
    }

    const currentUser = getCurrentUser();

    if (currentUser) {
      setCurrentUser(currentUser);
      fetchOrganizationData(currentUser.org_id).then((orgData) => {
        setOrganizationData(orgData);
      });
    }
    setIsSessionLoaded(true);
  }, []);

  return (
      <AppContext.Provider
        value={{
          projectInfo,
          setProjectInfo,
          bomSummary,
          setBomSummary,
          catalogs,
          setCatalogs,
          catalogsLoading,
          setCatalogsLoading,
          organizationData,
          setOrganizationData,
          forceRefreshSpaceConfigStatus,
          setForceRefreshSpaceConfigStatus,
          clearSearch,
          setClearSearch,
          isSubModule,
          setIsSubModule,
          isRemarksOn,
          setIsRemarksOn,
          isExpoOn,
          setIsExpoOn,
          orderContext,
          setOrderContext,
          currentUser,
          setCurrentUser,
          isSessionLoaded,
          cart,
          setCart,
          cartUuid,
          setCartUuid,
          isCartOpen,
          setIsCartOpen,
          openCart,
          closeCart,
          toggleCart,
          isAuthModalOpen,
          setIsAuthModalOpen,
          openAuthModal,
          closeAuthModal,
        }}
      >
        <div className="App">
          {AUTH_ROUTES.some((e) => location.pathname.startsWith(e)) ? (
            <AuthLayout />
          ) : (
            <Layout />
          )}
        </div>
      </AppContext.Provider>
  );
}

export default App;
